if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.productWrapper = this.closest("product-info");
        this.form = this.querySelector("form");
        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.cart) this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";

        if (this.form) {
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        
        const formIdAttr = this.form.getAttribute('id');
        const quantityInput = document.querySelector(`input[name="quantity"][form="${formIdAttr}"]`);
        if (quantityInput && quantityInput.value) {
          formData.set('quantity', quantityInput.value);
        }
        
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        let productGroup =
          this.closest(".product")?.querySelector("product-group");

        if (productGroup) {
          let productGroupCurrent = productGroup.dataset.selectedType;
          let productGroupCurrentItem = productGroupCurrent.split(":");
          let productGroupType = productGroupCurrentItem[0].trim();
          let productGroupData = productGroupCurrentItem[1].trim();

          formData.set(`[properties][${productGroupType}]`, productGroupData);
        }

        config.body = formData;

        const itemsToAdd = [];
        const additions = this.productWrapper
          ? this.productWrapper.querySelectorAll(".js-product-addition")
          : [];
        if (additions.length) {
          additions.forEach((addition) => {
            if (addition.checked) {
              let itemToAdd = {
                id: addition.value,
                quantity: 1,
              };

              if (addition.dataset.preorder) {
                itemToAdd.properties = {
                  'Estimated Delivery': addition.dataset.preorder
                }
              }

              itemsToAdd.push(itemToAdd);
            }
          });
        }

        if (itemsToAdd.length) {
          fetch(`${routes.cart_add_url}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: itemsToAdd,
            }),
          }).then(() => {
            this.addMainProduct(config);
          });
        } else {
          this.addMainProduct(config);
        }
      }

      addMainProduct(config) {
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
              });

            // Dispatch ContentSquare add-to-cart event on successful add
            if (!this.error && response && !response.status) {
              var addedSku = '';
              if (response.items && response.items.length) {
                addedSku = response.items[0].sku || '';
              } else if (response.sku) {
                addedSku = response.sku;
              }
              document.dispatchEvent(new CustomEvent('csq:addToCart', {
                detail: { sku: addedSku }
              }));
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
